import { match } from 'ts-pattern';

import {
  ClientPortalStepModel,
  ClientPortalStepTypeEnum,
  PropertyMappingEntityEnum,
} from '../../../shared/models';
import { extractMappingFromKey } from '../../../shared/properties';
import { JsonLogic } from '../../../utils';

// @TODO - E-5427 - Remove JsonLogic Var compatibility

/**
 * Convert old var in `jsonLogic` to be compatible with the new var format
 * - No more context: removing `global.` and `local.` in var name
 * - `current_individual.` is now `individual.` (for KYC individual_edit/custom_step and KYB individuals_edit)
 * - add `main_company.` for KYB company_edit/custom step
 * - add `affiliated_company.` for KYB company_edit/custom step
 *
 * @param jsonLogic
 * @param step
 * @returns jsonLogic compatible with new var name
 * @deprecated Should be removed in E-5427 - Remove JsonLogic Var compatibility
 */
export function jsonLogicVarCompatibility(
  jsonLogic: JsonLogic,
  step: Pick<ClientPortalStepModel, 'type'>,
): JsonLogic {
  if (!jsonLogic || !step) {
    return jsonLogic;
  }

  const jsonLogicString = JSON.stringify(jsonLogic);

  const compatibleJsonLogicString = jsonLogicString
    .replace(/global\./g, '')
    .replace(/current_individual/g, 'individual')
    .replace(
      /local\.([a-z_0-9]+)/g,
      // For local we need to replace depending of the step type
      (matchedString, key) => {
        return match(step.type)
          .with(
            ClientPortalStepTypeEnum.company_edit,
            () => `main_company.${key}`,
          )
          .with(
            ClientPortalStepTypeEnum.affiliated_companies_edit,
            () => `affiliated_company.${key}`,
          )
          .with(
            ClientPortalStepTypeEnum.individual_edit,
            () => `individual.${key}`,
          )
          .with(
            ClientPortalStepTypeEnum.individuals_edit,
            () => `individual.${key}`,
          )
          .with(ClientPortalStepTypeEnum.custom, () => {
            const { entity } = extractMappingFromKey(key);
            return match(entity)
              .with(PropertyMappingEntityEnum.case, () => `case.${key}`)
              .with(
                PropertyMappingEntityEnum.individual,
                () => `individual.${key}`,
              )
              .with(
                PropertyMappingEntityEnum.company,
                () => `main_company.${key}`,
              )
              .exhaustive();
          })
          .otherwise(
            () => matchedString, // Ignore other steps
          );
      },
    );

  return JSON.parse(compatibleJsonLogicString);
}
